import React, { useCallback, useEffect, useState } from 'react';
import { AppBar, Tabs, Tab, IconButton, Box } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import { useTranslation } from 'react-i18next';
import Breadcrumb from 'src/components/Breadcrumb';
import TabPanel from 'src/components/TabPanel/TabPanel';
import { InvestorDetailTabsIndex } from 'src/utils/investors';
import GeneralView from './General';
import KYCView from './KYC';
import InvestmentList from './Investments/InvestmentList';
import NuffiView from './NuffiDetail';

const GeneralMenuList = [
  {
    value: InvestorDetailTabsIndex.GENERAL,
    label: 'COMMON.GENERAL'
  },
  {
    value: InvestorDetailTabsIndex.KYC,
    label: 'KYC'
  },
  {
    value: InvestorDetailTabsIndex.IDENTITY,
    label: 'COMMON.IDENTITY'
  },
  {
    value: InvestorDetailTabsIndex.INVESTMENTS,
    label: 'COMMON.INVESTMENTS'
  },
  {
    value: InvestorDetailTabsIndex.ACCOUNT_STATEMENT,
    label: 'COMMON.ACCOUNTING_STATEMENTS',
    disabled: true
  }
];

const InvestorTabs = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id, tab } = useParams();

  const [value, setValue] = useState(false);

  const handleChange = useCallback(
    (_, newValue) => {
      setValue(newValue);
      navigate(`/investors/detail/${id}/${newValue}`);
    },
    [setValue]
  );

  useEffect(() => {
    if (id && !tab) {
      setValue(InvestorDetailTabsIndex.GENERAL);
    }
    if (tab) {
      if (Object.values(InvestorDetailTabsIndex).includes(tab)) {
        setValue(tab);
      } else {
        navigate(`/investors/detail/${id}`);
      }
    }
  }, [id, tab]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Breadcrumb doNotRedirectIndexList={[1]} />
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <IconButton onClick={() => navigate(-1)} color="primary" component="span">
          <ArrowLeft />
        </IconButton>
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          value={value}
          onChange={handleChange}
        >
          {GeneralMenuList.map(item => (
            <Tab
              key={item.value}
              label={t(item.label)}
              value={item.value}
              disabled={item.disabled}
            />
          ))}
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={InvestorDetailTabsIndex.GENERAL}>
        <GeneralView />
      </TabPanel>
      <TabPanel value={value} index={InvestorDetailTabsIndex.KYC}>
        <KYCView />
      </TabPanel>
      <TabPanel value={value} index={InvestorDetailTabsIndex.INVESTMENTS}>
        <InvestmentList />
      </TabPanel>
      <TabPanel value={value} index={InvestorDetailTabsIndex.IDENTITY}>
        <NuffiView />
      </TabPanel>
    </Box>
  );
};

export default InvestorTabs;
